const navigations = [
  {
    name: 'Home',
    path: '/'
  },
  {
    name: 'About',
    path: '/about/profile',
    order: '01',
    children: [
      {
        name: 'Overview',
        path: '/about/profile'
      },
      {
        name: 'Leadership',
        path: '/about/leaders'
      },
      // {
      //   name: 'Previous leaders',
      //   path: '/about/previous'
      // },
      {
        name: 'Administrative Staff',
        path: '/about/office'
      },
    ]
  },
  // {
  //   name: 'Faculty',
  //   path: '/faculty/teachers',
  //   order: '02',
  //   children: [
  //     {
  //       name: 'Teacher directory',
  //       path: '/faculty/teachers'
  //     },
  //     {
  //       name: 'Outstanding talent',
  //       path: '/faculty/talents'
  //     },
  //     {
  //       name: 'Postdoctoral',
  //       path: '/faculty/postdoc'
  //     }
  //   ],
  // },
  {
    name: 'News & Events',
    path: '/info/news',
    order: '02',
    children: [
      {
        name: 'News',
        path: '/info/news'
      },
      {
        name: 'Academic Activities',
        path: '/info/academic'
      },
      {
        name: 'Events',
        path: '/info/announcements'
      },
      {
        name: 'Recruitment',
        path: '/info/jobs'
      },
    ],
  },
  {
    name: 'Students',
    path: '/cultivate/postgraduate',
    order: '03',
    children: [
      {
        name: 'Graduate ',
        path: '/cultivate/postgraduate'
      },
    ]
  },
  {
    name: 'Research',
    path: '/research/bases',
    order: '04',
    children: [
      {
        name: 'Centers & Labs',
        path: '/research/bases'
      },
      {
        name: 'Achievements',
        path: '/research/results'
      },
    ],
  },
]

export default navigations



// WEBPACK FOOTER //
// ./src/utils/lang/navigations.en.js